<template>
  <div class="nav-link-container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'NavLink'
}
</script>

<style scoped>
.nav-link-container {
  @apply h-full flex items-center uppercase;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
}

.nav-link-container :deep(a:not(.router-link-active):not(button)) {
  @apply text-white/55 hover:text-white transition-colors duration-200;
  font-weight: 400;
}

.nav-link-container :deep(.router-link-active:not(button)) {
  @apply text-white;
  font-weight: 400;
}

/* Logo specific styling */
.nav-link-container :deep(img) {
  height: 32px;
}

@media (min-width: 768px) {
  .nav-link-container :deep(img) {
    height: 90px !important;
  }
}
</style> 